// Pause du fond (WCAG 2.2.2), choisie dans le pied de page et retenue d'une visite à l'autre :
// <html data-motion="paused"> fige les animations.
const MOTION_KEY = "studiotv-motion";

export function motionPaused() {
  try {
    return localStorage.getItem(MOTION_KEY) === "paused";
  } catch {
    return false; // stockage bloqué (navigation privée)
  }
}

export function setMotionPaused(paused: boolean) {
  if (paused) document.documentElement.dataset.motion = "paused";
  else delete document.documentElement.dataset.motion;
  try {
    if (paused) localStorage.setItem(MOTION_KEY, "paused");
    else localStorage.removeItem(MOTION_KEY);
  } catch {
    /* le choix vaut pour cette visite seulement */
  }
}
